import { type UseMutationResult, useMutation, useQueryClient } from 'react-query';
import { toast } from 'react-toastify';
import { OpenAPI } from '../../services/wealthlane-captable-services/core/OpenAPI';
import { request as __request } from '../../services/wealthlane-captable-services/core/request';
import ToastComponent from '../../components/toast';

const usePostWarrantCalculateExercise = (
  handleRequest: <T>(request: Promise<T>) => Promise<T | undefined>,
  newData: any,
  setNewData: any,
  setCalculated: any,
  setExerciseResponse: any,
  exerciseResponse: any
): UseMutationResult<any | undefined, unknown, any, unknown> => {
  return useMutation(
    async (payload) => {
      const newPayload = {
        warrantId: payload?.warrantId,
        exerciseQuantity: Number(payload?.exerciseShares),
        settlementTypeId: payload?.settlementTypeId,
        fairMarketValue: payload?.fmv,
        currentStockPrice: payload?.currentStockPrice || 0,
        totalTaxes: 0,
        totalCommission: 0,
        totalOtherFees: 0,
        priorFunding: 0,
      };
      const result: any = await handleRequest(
        __request(OpenAPI, {
          method: 'POST',
          url: '/api/cap-table/api/app/warrant-participant/calculate-exercise',
          body: newPayload,
          mediaType: 'application/json',
          errors: {
            400: 'Bad Request',
            401: 'Unauthorized',
            403: 'Forbidden',
            404: 'Not Found',
            500: 'Internal Server Error',
            501: 'Not Implemented',
          },
        })
      );
      if (result) {
        result._rowId = payload?.rowId;
        result.warrantId = payload?.warrantId;
      }
      return result;
    },
    {
      onSuccess: async (response: any) => {
        if (response != null) {
          toast.success(<ToastComponent label='Success' message='Exercise Calculated.' />);

          const targetRowId = response._rowId;
          const filter: any = newData?.find((item: any) => item?.id === targetRowId);
          if (filter) {
            filter.netShare = response?.netShares;
            filter.netCash = response?.netCash;

            const existingIndex = newData.findIndex((item: any) => item?.id === targetRowId);
            newData[existingIndex] = filter;
            setNewData([...newData]);
          }
          setCalculated(true);

          const updatedExerciseResponse = exerciseResponse.map((item: any) => {
            if (item.warrantId === response.warrantId) {
              return response;
            }
            return item;
          });

          if (!exerciseResponse.find((item: any) => item.warrantId === response.warrantId)) {
            updatedExerciseResponse.push(response);
          }

          setExerciseResponse(updatedExerciseResponse);
        }
      },
      onError: (err) => {
        console.log('error', err);
      },
    }
  );
};

export default usePostWarrantCalculateExercise;
